import { useEffect } from 'react';
import { identify, init } from '@fullstory/browser';

const CIMPRESS_FULLSTORY_ORG_ID = '97CT5';
const canonicalId = 'https://claims.cimpress.io/canonical_id';

const FullStory = ({ isProduction, profile }) => {
  useEffect(() => {
    init({ orgId: CIMPRESS_FULLSTORY_ORG_ID, devMode: !isProduction });
  }, [isProduction]);

  useEffect(() => {
    const user = profile[canonicalId];
    const { name: displayName, email } = profile;
    if (user) identify(user, { displayName, email });
  }, [profile]);

  return null;
};

export default FullStory;
